export default __webpack_public_path__ + "images/f3b7695d8a619f0e59ffb194d125937b.png";